module.exports = __webpack_public_path__ + "assets/img/arrow-left@1,5x.205273c5.svg";